import { Button } from "@/components/ui/button";
import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from "@/components/ui/card";
import { Sliders } from "lucide-react";
import { Link } from "react-router-dom";

export function TierLimitsCard() {
  return (
    <Card className="hover:shadow-lg transition-shadow">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Sliders className="h-5 w-5" />
          Tier Limits
        </CardTitle>
        <CardDescription>
          Configure global tier limits and user-specific overrides for recipe boxes, members, and recipes.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Button asChild>
          <Link to="/admin/tier-limits">Manage Tier Limits</Link>
        </Button>
      </CardContent>
    </Card>
  );
}
